import { useQuery } from 'react-query';
import axios from 'axios';

const fetchData = async (url) => {
    const { data } = await axios.get(url);
    return data;
};

export const useFetchData = (url) => {
    return useQuery(['data', url], () => fetchData(url), {
        staleTime: 1000 * 60 * 5, // 5 minutes
    });
};
